import styled from 'styled-components';

export const Legend = styled.div`
  margin: 20px 0;
`;

export const Color = styled.div`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
`;
